// Helpers
import { getOutlinedPositionIcon } from "@/Common/helpers/Positions/icons";
import { supportedSystemPositions } from "@/Common/helpers/Positions";

import PageLayer from "@/Layouts/views/PageLayer";
import TechniciansWashoutLayer from "@/Washouts/views/Layers/Technicians/TechniciansWashoutLayer";
import actionsList from "@Constants/actionsList";

const positions = supportedSystemPositions();
const POSITION = positions.BODY_SHOP.BODY_SHOP_PAINTER;

const BodyShopPainter = () => {
	const Icon = getOutlinedPositionIcon({ position: POSITION });
	const actions = {
		OVERRIDE_COMPENSATION: actionsList.OVERRIDE_BODY_SHOP_PAINTER_COMPENSATION,
	};
	return (
		<PageLayer title={`${POSITION} Washouts`} icon={Icon}>
			<TechniciansWashoutLayer position={POSITION} actions={actions} />
		</PageLayer>
	);
};

export default BodyShopPainter;
